
import { defineComponent, ref } from 'vue';
import { RatingType, LectureType } from '@/utils/config';
import { RatingHeadBar, LectureList, RatingList } from './components';

type TabType = RatingType | LectureType;

export default defineComponent({
  components: {
    RatingHeadBar,
    LectureList,
    RatingList,
  },
  setup() {
    /** 激活 tab */
    const activeTab = ref<TabType>('最新');
    return {
      activeTab,
    };
  },
});
